
const MONITOR_INTERVAL = 10 * 1000;

class DataManager {
	constructor() {
		this.nextId = 0;
		this.records = [];
	}

	async getDataValues(dataKeys) {
		//return await global.dipClient.getDataValues(dataKeys);
		return {
			"data1": Date.now().toString(),
			"data2": "this is text substitute",
			"data3": "거짓",
		};
	}

	collectDataKeys(collected, dataKeys) {
		for (let i = 0; i < dataKeys.length; i++) {
			for (let j = 0; j < collected.length; j++) {
				if (dataKeys[i] === collected[j]) return;
			}
			collected.push(dataKeys[i]);
		}
	}

	async update() {
		let dataKeys = [];
		for (let i = 0; i < this.records.length; i++) {
			this.collectDataKeys(dataKeys, this.records[i].dataKeys);
		}

		let dataValues = await this.getDataValues(dataKeys);
		for (let i = 0; i < this.records.length; i++) {
			this.records[i].onChange(dataValues);
		}

		this.timer = setTimeout(this.update.bind(this), MONITOR_INTERVAL);
	}

	register(dataKeys, onChange) {
		if (Array.isArray(dataKeys) && onChange) {
			let id = this.nextId++;

			this.records.push({
				id: id,
				dataKeys: dataKeys,
				onChange: onChange
			});

			// enforces the update immediately
			if (this.timer) {
				clearTimeout(this.timer);
			}
			this.timer = setTimeout(this.update.bind(this), 0);

			return id;
		}
	}

	unregister(id) {
		for (let i = 0; i < this.records.length; i++) {
			if (this.records[i].id === id) {
				this.records.splice(i, 1);
				return;
			}
		}

		if (this.records.length === 0 && this.timer) {
			clearTimeout(this.timer);
		}
	}
}

export default DataManager;
